import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import notAuth from '@src/LottieAnimations/notAuth.json';
import { LottieLite } from '@src/LottieAnimations/LottieLite';

const NoAuthorization: FC = () => {
  const navigate = useNavigate();

  const containerStyle: React.CSSProperties = {
    fontFamily: 'Plus Jakarta Sans',
    backgroundColor: '#57568e',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    padding: '24px',
    boxSizing: 'border-box',
  };

  const contentStyle: React.CSSProperties = {
    width: '100%',
    maxWidth: '760px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  };

  const animationWrapperStyle: React.CSSProperties = {
    width: '100%',
    maxWidth: '720px',
    height: '380px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    overflow: 'hidden',
    marginBottom: '28px',
    marginLeft: '-74px',
  };

  const animationStyle: React.CSSProperties = {
    width: 'min(100%, 640px)',
    aspectRatio: '1 / 1',
    transform: 'translateY(-104px)',
    flexShrink: 0,
  };

  const headingStyle: React.CSSProperties = {
    fontSize: '36px',
    color: '#fff',
    lineHeight: 1.1,
    margin: '0 0 14px',
  };

  const paragraphStyle: React.CSSProperties = {
    fontSize: '18px',
    color: '#fff',
    lineHeight: 1.5,
    margin: '0 0 20px',
    maxWidth: '520px',
  };

  const buttonStyle: React.CSSProperties = {
    padding: '12px 24px',
    fontSize: '16px',
    color: '#fff',
    backgroundColor: '#4f7eff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    textDecoration: 'none',
  };

  const handleGoBack = () => {
    navigate('/', { replace: true });
  };

  return (
    <div style={containerStyle}>
      <div style={contentStyle}>
        <div style={animationWrapperStyle}>
          <LottieLite animationData={notAuth} style={animationStyle} />
        </div>
        <h1 style={headingStyle}>Oops! Access Denied</h1>
        <p style={paragraphStyle}>
          You don&apos;t have permission to view this page.
        </p>
        <button style={buttonStyle} onClick={handleGoBack}>
          Go To Home Page
        </button>
      </div>
    </div>
  );
};

export default NoAuthorization;
